import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-flexi-funeral-quote.component.scss";
var FormItemFlexiFuneralQuote = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemFlexiFuneralQuote, _super);
    function FormItemFlexiFuneralQuote(element) {
        var _this = _super.call(this, element) || this;
        _this.child = [];
        _this.parent = [];
        _this.extendedFamily = [];
        _this.totalCoverAmount = 0;
        return _this;
    }
    FormItemFlexiFuneralQuote.prototype.init = function () {
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formFields = this.element.querySelector(".form__fields--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.form = this.element.querySelector("form");
        this.buttonNextStep2 = this.element.querySelector(".js_next-step-2-button");
        this.buttonSubmit = this.element.querySelector(".js_step-submit-button");
        this.callMeBackButton = this.element.querySelector(".js-apply-now-ffq__button--cmb");
        this.approvedContainer = this.element.querySelector(".form__success--container-pc");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.personsToCover = Array.from(this.form.querySelectorAll(".person-to-cover"));
        this.coverAmounts = Array.from(this.form.querySelectorAll(".cover-amount"));
        this.mainInsuredID = this.form.querySelector("input[name=identification-1]");
        this.dateOfBirths = Array.from(this.form.querySelectorAll(".dob"));
        this.genders = Array.from(this.form.querySelectorAll("input[type=radio]"));
        this.firstNames = Array.from(this.form.querySelectorAll(".first-name"));
        this.lastNames = Array.from(this.form.querySelectorAll(".last-name"));
        this.addedMembers = Array.from(this.form.querySelectorAll(".add-member"));
        this.mainInsuredPhoneNumber = this.form.querySelector("input[name=phone-number]");
        this.mainInsuredEmail = this.form.querySelector("input[name=email-address]");
        this.hLines = Array.from(this.form.querySelectorAll(".h-line"));
        this.quoteDetails = this.form.querySelector("label[name=quote-details]");
        this.errorDetails = "";
        var _loop_1 = function (i) {
            var personToCoverGroup = this_1.personsToCover
                .find(function (x) { return x.name === "person-to-cover-" + i; })
                .closest(".form__group");
            personToCoverGroup.classList.add("form__group--hidden");
            var coverAmountGroup = this_1.coverAmounts
                .find(function (x) { return x.name === "cover-amount-" + i; })
                .closest(".form__group");
            coverAmountGroup.classList.add("form__group--hidden");
            var dateOfBirthGroup = this_1.dateOfBirths
                .find(function (x) { return x.name === "dob-" + i; })
                .closest(".form__group");
            dateOfBirthGroup.classList.add("form__group--hidden");
            var genderGroup = this_1.genders
                .find(function (x) { return x.name === "gender-" + i; })
                .closest(".form__group");
            genderGroup.classList.add("form__group--hidden");
            var firstNameGroup = this_1.firstNames
                .find(function (x) { return x.name === "first-name-" + i; })
                .closest(".form__group");
            firstNameGroup.classList.add("form__group--hidden");
            var lastNameGroup = this_1.lastNames
                .find(function (x) { return x.name === "last-name-" + i; })
                .closest(".form__group");
            lastNameGroup.classList.add("form__group--hidden");
            // -- HORIZONAL LINE TO SHOW SEPARATION -- //
            var hLineGroup = this_1.hLines
                .find(function (x) { return x.id === "h-line-" + i; })
                .closest(".form__group");
            hLineGroup.classList.add("form__group--hidden");
            // -- Skip Add MEMBER 2 (Show to add 2nd MEMBER) -- //
            if (i !== 2) {
                var addMemberGroup = this_1.addedMembers
                    .find(function (x) { return x.name === "add-member-" + i; })
                    .closest(".form__group");
                addMemberGroup.classList.add("form__group--hidden");
            }
        };
        var this_1 = this;
        // -- There are a maximum of 4 members for the insurance quote - MAIN MEMBER (1) is compulsory -- //
        // -- Hide Other MEMBER elements -- //
        for (var i = 2; i <= 4; i++) {
            _loop_1(i);
        }
    };
    FormItemFlexiFuneralQuote.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (event) {
                var validationErrors = false;
                validationErrors = _this.flexibleFuneralValidations();
                if (!validationErrors) {
                    var _button = event.target;
                    var _form = _button.closest("form");
                    var formFields = _form.querySelectorAll("input, select");
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                    if (valid.length === 0) {
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.quoteDetails.innerHTML = _this.formatValidationMessage(_this.errorDetails);
                }
            });
        }
        if (this.callMeBackButton) {
            this.callMeBackButton.addEventListener("click", function (event) {
                _this.submitCMBForm(_this.form);
            });
        }
        if (this.buttonNextStep2) {
            this.buttonNextStep2.addEventListener("click", function (event) {
                _this.getAllMembersInformation();
                // -- Main Insured -- //
                _this.quoteDetails.innerHTML =
                    "<h6>Main Insured:</h6>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li><b>First Name: </b>" +
                        _this.mainInsuredAllDetails.firstName +
                        "</li>\n\t\t\t\t\t\t<li><b>Surname: </b>" +
                        _this.mainInsuredAllDetails.surname +
                        "</li>\n\t\t\t\t\t\t<li><b>ID Number: </b>" +
                        _this.mainInsuredAllDetails.identityNumber +
                        "</li>\n\t\t\t\t\t\t<li><b>Cover Amount: </b>" +
                        Number(_this.mainInsuredAllDetails.sumInsured).toLocaleString("en-ZA", {
                            style: "currency",
                            currency: "ZAR",
                            minimumFractionDigits: 2,
                        }) +
                        "</li>\n\t\t\t\t\t\t<li><b>Phone Number: </b>" +
                        _this.mainInsuredAllDetails.phoneNumber +
                        "</li>\n\t\t\t\t\t\t<li><b>Email: </b>" +
                        _this.mainInsuredAllDetails.email +
                        "</li>\n\t\t\t\t\t</ul>";
                // -- Spouse -- //
                if (_this.spouse) {
                    _this.quoteDetails.innerHTML +=
                        "<h6>Spouse:</h6>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li><b>First Name: </b>" +
                            _this.spouse.firstName +
                            "</li>\n\t\t\t\t\t\t\t<li><b>Surname: </b>" +
                            _this.spouse.surname +
                            "</li>\n\t\t\t\t\t\t\t<li><b>Cover Amount: </b>" +
                            Number(_this.spouse.sumInsured).toLocaleString("en-ZA", {
                                style: "currency",
                                currency: "ZAR",
                                minimumFractionDigits: 2,
                            }) +
                            "</li>\n\t\t\t\t\t\t\t<li><b>Gender: </b>" +
                            _this.spouse.gender +
                            "</li>\n\t\t\t\t\t\t\t<li><b>Date of Birth: </b>" +
                            _this.spouse.dateOfBirth +
                            "</li>\n\t\t\t\t\t\t</ul>";
                }
                // -- Children -- //
                if (_this.child.length > 0) {
                    _this.child.forEach(function (element) {
                        _this.quoteDetails.innerHTML +=
                            "<h6>Child:</h6>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li><b>First Name: </b>" +
                                element.firstName +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Surname: </b>" +
                                element.surname +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Cover Amount: </b>" +
                                Number(element.sumInsured).toLocaleString("en-ZA", {
                                    style: "currency",
                                    currency: "ZAR",
                                    minimumFractionDigits: 2,
                                }) +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Gender: </b>" +
                                element.gender +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Date of Birth: </b>" +
                                element.dateOfBirth +
                                "</li>\n\t\t\t\t\t\t\t</ul>";
                    });
                }
                // -- Parents -- //
                if (_this.parent.length > 0) {
                    _this.parent.forEach(function (element) {
                        _this.quoteDetails.innerHTML +=
                            "<h6>Parent:</h6>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li><b>First Name: </b>" +
                                element.firstName +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Surname: </b>" +
                                element.surname +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Cover Amount: </b>" +
                                Number(element.sumInsured).toLocaleString("en-ZA", {
                                    style: "currency",
                                    currency: "ZAR",
                                    minimumFractionDigits: 2,
                                }) +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Gender: </b>" +
                                element.gender +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Date of Birth: </b>" +
                                element.dateOfBirth +
                                "</li>\n\t\t\t\t\t\t\t</ul>";
                    });
                }
                // -- Extended Family -- //
                if (_this.extendedFamily.length > 0) {
                    _this.extendedFamily.forEach(function (element) {
                        _this.quoteDetails.innerHTML +=
                            "<h6>Extended Family:</h6>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li><b>First Name: </b>" +
                                element.firstName +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Surname: </b>" +
                                element.surname +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Cover Amount: </b>" +
                                Number(element.sumInsured).toLocaleString("en-ZA", {
                                    style: "currency",
                                    currency: "ZAR",
                                    minimumFractionDigits: 2,
                                }) +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Gender: </b>" +
                                element.gender +
                                "</li>\n\t\t\t\t\t\t\t\t<li><b>Date of Birth: </b>" +
                                element.dateOfBirth +
                                "</li>\n\t\t\t\t\t\t\t</ul>";
                    });
                }
            });
        }
        var _loop_2 = function (i) {
            (function (count, personsToCover, coverAmounts, dateOfBirths, genders, firstNames, lastNames, addedMembers, hLines) {
                var addMember = addedMembers.find(function (x) { return x.name === "add-member-" + i; });
                addMember.addEventListener("click", function (event) {
                    var addMemberGroup = addMember.closest(".form__group");
                    addMemberGroup.classList.add("form__group--hidden");
                    var personToCoverGroup = personsToCover
                        .find(function (x) { return x.name === "person-to-cover-" + i; })
                        .closest(".form__group");
                    personToCoverGroup.classList.remove("form__group--hidden");
                    var coverAmountGroup = coverAmounts
                        .find(function (x) { return x.name === "cover-amount-" + i; })
                        .closest(".form__group");
                    coverAmountGroup.classList.remove("form__group--hidden");
                    var dateOfBirthGroup = dateOfBirths
                        .find(function (x) { return x.name === "dob-" + i; })
                        .closest(".form__group");
                    dateOfBirthGroup.classList.remove("form__group--hidden");
                    var genderGroup = genders
                        .find(function (x) { return x.name === "gender-" + i; })
                        .closest(".form__group");
                    genderGroup.classList.remove("form__group--hidden");
                    var firstNameGroup = firstNames
                        .find(function (x) { return x.name === "first-name-" + i; })
                        .closest(".form__group");
                    firstNameGroup.classList.remove("form__group--hidden");
                    var lastNameGroup = lastNames
                        .find(function (x) { return x.name === "last-name-" + i; })
                        .closest(".form__group");
                    lastNameGroup.classList.remove("form__group--hidden");
                    // HORIZONAL LINE TO SHOW SEPARATION
                    var hLineGroup = hLines
                        .find(function (x) { return x.id === "h-line-" + i; })
                        .closest(".form__group");
                    hLineGroup.classList.remove("form__group--hidden");
                    // There is no 5th member
                    if (i !== 4) {
                        // (i+1) to add additional member
                        var addNextMemberGroup = addedMembers
                            .find(function (x) { return x.name === "add-member-" + (i + 1); })
                            .closest(".form__group");
                        addNextMemberGroup.classList.remove("form__group--hidden");
                    }
                });
            })(i, this_2.personsToCover, this_2.coverAmounts, this_2.dateOfBirths, this_2.genders, this_2.firstNames, this_2.lastNames, this_2.addedMembers, this_2.hLines);
        };
        var this_2 = this;
        // -- Add MEMBERS 2 - 4 with the add MEMBER click -- //
        // -- Pass required variables to use for members -- //
        for (var i = 2; i <= 4; i++) {
            _loop_2(i);
        }
        // -- ADD GENDER SELECTION FOR GENDERS 2-4
        this.genders
            .filter(function (x) { return x.name === "gender-2"; })
            .map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.gender2 = evt.value;
            });
        });
        this.genders
            .filter(function (x) { return x.name === "gender-3"; })
            .map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.gender3 = evt.value;
            });
        });
        this.genders
            .filter(function (x) { return x.name === "gender-4"; })
            .map(function (item) {
            return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.gender4 = evt.value;
            });
        });
        // -- Update PERSONS TO COVER DROP DOWN -- //
        // -- ONLY A MAX OF 1 SPOUSE -- //
        // -- ONLY A MAX OF 2 CHILDREN -- //
        this.personsToCover.map(function (item) {
            return item.addEventListener("change", function (event) {
                _this.updatePersonsToCover();
            });
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            // allow individual form items components to handle form reset
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            _this.resetForm();
        }, false);
    };
    // -- Update PERSONS TO COVER DROP DOWN -- //
    // -- ONLY A MAX OF 1 SPOUSE -- //
    // -- ONLY A MAX OF 2 CHILDREN -- //
    FormItemFlexiFuneralQuote.prototype.updatePersonsToCover = function () {
        var numberOfSpouses = 0; // -- MAXIMUM OF 1 SPOUSE -- //
        var numberOfChildren = 0; // -- MAXIMUM OF 2 CHILDREN -- //
        this.personsToCover.forEach(function (element) {
            var personToCover = element.options[element.selectedIndex].value;
            if (personToCover === "SPOUSE") {
                numberOfSpouses++;
            }
            if (personToCover === "CHILD") {
                numberOfChildren++;
            }
        });
        // -- ONLY A MAX OF 1 SPOUSE -- //
        if (numberOfSpouses >= 1) {
            this.personsToCover.forEach(function (element) {
                for (var i = 0; i < element.length; i++) {
                    if (element.options[i].value === "SPOUSE" &&
                        element.options[element.selectedIndex].value !==
                            "SPOUSE") {
                        element.removeChild(element.options[i]);
                        break;
                    }
                }
            });
        }
        else {
            this.personsToCover.forEach(function (element) {
                var hasSpouseElement = false;
                for (var i = 0; i < element.length; i++) {
                    if (element.options[i].value === "SPOUSE") {
                        hasSpouseElement = true;
                        break;
                    }
                }
                if (hasSpouseElement === false) {
                    var childOption = document.createElement("option");
                    childOption.value = "SPOUSE";
                    childOption.text = "My Spouse";
                    element.add(childOption);
                }
            });
        }
        // -- ONLY A MAX OF 2 CHILDREN -- //
        if (numberOfChildren >= 2) {
            this.personsToCover.forEach(function (element) {
                for (var i = 0; i < element.length; i++) {
                    if (element.options[i].value === "CHILD" &&
                        element.options[element.selectedIndex].value !== "CHILD") {
                        element.removeChild(element.options[i]);
                        break;
                    }
                }
            });
        }
        else {
            this.personsToCover.forEach(function (element) {
                var hasChildElement = false;
                for (var i = 0; i < element.length; i++) {
                    if (element.options[i].value === "CHILD") {
                        hasChildElement = true;
                        break;
                    }
                }
                if (hasChildElement === false) {
                    var childOption = document.createElement("option");
                    childOption.value = "CHILD";
                    childOption.text = "My Child";
                    element.add(childOption);
                }
            });
        }
    };
    FormItemFlexiFuneralQuote.prototype.getGenderFromID = function (idNumber) {
        var genderValue = Number(idNumber.charAt(6));
        if (genderValue >= 0 && genderValue <= 4) {
            return "FEMALE";
        }
        else {
            return "MALE";
        }
    };
    FormItemFlexiFuneralQuote.prototype.getDOBFromID = function (idNumber) {
        var yearValue = Number(idNumber.substr(0, 2));
        var year = "";
        var month = idNumber.substr(2, 2);
        var day = idNumber.substr(4, 2);
        // -- START FROM YEAR 1920 FOR SOUTH AFRICAN ID NUMBER SYNTAX (~ 100 YEARS) -- //
        if (yearValue >= 20) {
            year = "19" + yearValue.toString();
            // -- ELSE START FROM YEAR 2000 FOR SOUTH AFRICAN ID NUMBER SYNTAX -- //
        }
        else {
            year = "00" + yearValue.toString();
        }
        return year + "-" + month + "-" + day;
    };
    // -- GET ALL MEMBERS DATA -- //
    FormItemFlexiFuneralQuote.prototype.getAllMembersInformation = function () {
        this.spouse = null;
        this.child = [];
        this.parent = [];
        this.extendedFamily = [];
        this.totalCoverAmount = 0;
        var _loop_3 = function (i) {
            // -- MAIN INSURED -- //
            if (i === 1) {
                var firstNameMainInsured = this_3.firstNames.find(function (x) { return x.name === "first-name-" + i; }).value;
                var lastNameMainInsured = this_3.lastNames.find(function (x) { return x.name === "last-name-" + i; }).value;
                var amountInsuredMainInsured = this_3.coverAmounts.find(function (x) { return x.name === "cover-amount-" + i; }).value;
                var idNumberMainInsured = this_3.mainInsuredID.value;
                var genderMainInsured = this_3.getGenderFromID(idNumberMainInsured);
                var dobMainInsured = this_3.getDOBFromID(idNumberMainInsured);
                // -- Main insured phone number will not be sent to backend -- //
                // -- Main insured email will not be sent to backend -- //
                var phoneNumberMainInsured = this_3.mainInsuredPhoneNumber.value;
                var emailMainInsured = this_3.mainInsuredEmail.value;
                this_3.totalCoverAmount += Number(amountInsuredMainInsured);
                this_3.mainInsuredAllDetails = {
                    firstName: firstNameMainInsured,
                    surname: lastNameMainInsured,
                    sumInsured: amountInsuredMainInsured,
                    identityNumber: idNumberMainInsured,
                    gender: genderMainInsured,
                    dateOfBirth: dobMainInsured,
                    phoneNumber: phoneNumberMainInsured,
                    email: emailMainInsured,
                };
                this_3.mainInsured = {
                    firstName: firstNameMainInsured,
                    surname: lastNameMainInsured,
                    sumInsured: amountInsuredMainInsured,
                    identityNumber: idNumberMainInsured,
                    gender: genderMainInsured,
                    dateOfBirth: dobMainInsured,
                };
            }
            else {
                var personToCover = this_3.personsToCover.find(function (x) { return x.name === "person-to-cover-" + i; }).value;
                if (personToCover === "SPOUSE") {
                    var firstNamePersonToCover = this_3.firstNames.find(function (x) { return x.name === "first-name-" + i; }).value;
                    var lastNamePersonToCover = this_3.lastNames.find(function (x) { return x.name === "last-name-" + i; }).value;
                    var amountInsuredPersonToCover = this_3.coverAmounts.find(function (x) { return x.name === "cover-amount-" + i; }).value;
                    this_3.totalCoverAmount += Number(amountInsuredPersonToCover);
                    var genderPersonToCover = void 0;
                    if (i === 2) {
                        genderPersonToCover = this_3.gender2;
                    }
                    else if (i === 3) {
                        genderPersonToCover = this_3.gender3;
                    }
                    else if (i === 4) {
                        genderPersonToCover = this_3.gender4;
                    }
                    var dobPersonToCover = this_3.dateOfBirths.find(function (x) { return x.name === "dob-" + i; }).value;
                    dobPersonToCover = dobPersonToCover.replace(/\//g, "-");
                    this_3.spouse = {
                        firstName: firstNamePersonToCover,
                        surname: lastNamePersonToCover,
                        sumInsured: amountInsuredPersonToCover,
                        gender: genderPersonToCover,
                        dateOfBirth: dobPersonToCover,
                    };
                }
                else if (personToCover === "CHILD") {
                    var firstNamePersonToCover = this_3.firstNames.find(function (x) { return x.name === "first-name-" + i; }).value;
                    var lastNamePersonToCover = this_3.lastNames.find(function (x) { return x.name === "last-name-" + i; }).value;
                    var amountInsuredPersonToCover = this_3.coverAmounts.find(function (x) { return x.name === "cover-amount-" + i; }).value;
                    this_3.totalCoverAmount += Number(amountInsuredPersonToCover);
                    var genderPersonToCover = void 0;
                    if (i === 2) {
                        genderPersonToCover = this_3.gender2;
                    }
                    else if (i === 3) {
                        genderPersonToCover = this_3.gender3;
                    }
                    else if (i === 4) {
                        genderPersonToCover = this_3.gender4;
                    }
                    var dobPersonToCover = this_3.dateOfBirths.find(function (x) { return x.name === "dob-" + i; }).value;
                    dobPersonToCover = dobPersonToCover.replace(/\//g, "-");
                    var childPersonToCover = {
                        firstName: firstNamePersonToCover,
                        surname: lastNamePersonToCover,
                        sumInsured: amountInsuredPersonToCover,
                        gender: genderPersonToCover,
                        dateOfBirth: dobPersonToCover,
                    };
                    this_3.child.push(childPersonToCover);
                }
                else if (personToCover === "PARENT") {
                    var firstNamePersonToCover = this_3.firstNames.find(function (x) { return x.name === "first-name-" + i; }).value;
                    var lastNamePersonToCover = this_3.lastNames.find(function (x) { return x.name === "last-name-" + i; }).value;
                    var amountInsuredPersonToCover = this_3.coverAmounts.find(function (x) { return x.name === "cover-amount-" + i; }).value;
                    this_3.totalCoverAmount += Number(amountInsuredPersonToCover);
                    var genderPersonToCover = void 0;
                    if (i === 2) {
                        genderPersonToCover = this_3.gender2;
                    }
                    else if (i === 3) {
                        genderPersonToCover = this_3.gender3;
                    }
                    else if (i === 4) {
                        genderPersonToCover = this_3.gender4;
                    }
                    var dobPersonToCover = this_3.dateOfBirths.find(function (x) { return x.name === "dob-" + i; }).value;
                    dobPersonToCover = dobPersonToCover.replace(/\//g, "-");
                    var parentPersonToCover = {
                        firstName: firstNamePersonToCover,
                        surname: lastNamePersonToCover,
                        sumInsured: amountInsuredPersonToCover,
                        gender: genderPersonToCover,
                        dateOfBirth: dobPersonToCover,
                    };
                    this_3.parent.push(parentPersonToCover);
                }
                else if (personToCover === "EXTENDED") {
                    var firstNamePersonToCover = this_3.firstNames.find(function (x) { return x.name === "first-name-" + i; }).value;
                    var lastNamePersonToCover = this_3.lastNames.find(function (x) { return x.name === "last-name-" + i; }).value;
                    var amountInsuredPersonToCover = this_3.coverAmounts.find(function (x) { return x.name === "cover-amount-" + i; }).value;
                    this_3.totalCoverAmount += Number(amountInsuredPersonToCover);
                    var genderPersonToCover = void 0;
                    if (i === 2) {
                        genderPersonToCover = this_3.gender2;
                    }
                    else if (i === 3) {
                        genderPersonToCover = this_3.gender3;
                    }
                    else if (i === 4) {
                        genderPersonToCover = this_3.gender4;
                    }
                    var dobPersonToCover = this_3.dateOfBirths.find(function (x) { return x.name === "dob-" + i; }).value;
                    dobPersonToCover = dobPersonToCover.replace(/\//g, "-");
                    var extendedPersonToCover = {
                        firstName: firstNamePersonToCover,
                        surname: lastNamePersonToCover,
                        sumInsured: amountInsuredPersonToCover,
                        gender: genderPersonToCover,
                        dateOfBirth: dobPersonToCover,
                    };
                    this_3.extendedFamily.push(extendedPersonToCover);
                }
            }
        };
        var this_3 = this;
        // -- GET ALL MEMBERS DATA -- //
        for (var i = 1; i <= 4; i++) {
            _loop_3(i);
        }
    };
    FormItemFlexiFuneralQuote.prototype.formatValidationMessage = function (validationMessage) {
        // Match Regex to find currency values
        var currencyFormat = /R[1-9]+/g;
        var results = validationMessage.match(currencyFormat);
        if (results) {
            var startIndex_1 = 0;
            results.forEach(function (element) {
                var numberIndex = validationMessage.indexOf(element, startIndex_1);
                var pointIndex = validationMessage.indexOf(".", numberIndex);
                var AmountLength = pointIndex + 2 - (numberIndex - 1);
                var currencyAmount = validationMessage.substr(numberIndex, AmountLength);
                var newCurrencyAmount = currencyAmount.replace(" ", "&nbsp;");
                validationMessage = validationMessage.replace(currencyAmount, "<b>" + newCurrencyAmount + "</b>");
                startIndex_1 = pointIndex;
            });
            var validationMessageArray = validationMessage.split("\r\n");
            validationMessageArray = validationMessageArray.filter(function (item, pos, self) {
                return self.indexOf(item) === pos;
            });
            var newValidationMessage_1 = "<ul>";
            validationMessageArray.forEach(function (element) {
                newValidationMessage_1 += "<li>" + element + "</li>";
            });
            newValidationMessage_1 += "</ul>";
            return newValidationMessage_1;
        }
        else {
            var validationMessageArray = validationMessage.split("\r\n");
            validationMessageArray = validationMessageArray.filter(function (item, pos, self) {
                return self.indexOf(item) === pos;
            });
            var newValidationMessage_2 = "<ul>";
            validationMessageArray.forEach(function (element) {
                newValidationMessage_2 += "<li>" + element + "</li>";
            });
            newValidationMessage_2 += "</ul>";
            return newValidationMessage_2;
        }
    };
    FormItemFlexiFuneralQuote.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var successApplyCMB = form.querySelector(".form__success--container-pc");
        var error = form.querySelector(".form__error--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // display fields
        var coverAmount = form.querySelector(".form__success-container__ffq--cover-amount");
        var premium = form.querySelector(".form__success-container__ffq--premium");
        var allMembersData = {};
        var postData = "";
        allMembersData["mainInsured"] = this.mainInsured;
        if (this.spouse) {
            allMembersData["spouse"] = this.spouse;
        }
        if (this.child.length > 0) {
            allMembersData["child"] = this.child;
        }
        if (this.parent.length > 0) {
            allMembersData["parent"] = this.parent;
        }
        if (this.extendedFamily.length > 0) {
            allMembersData["extendedFamily"] = this.extendedFamily;
        }
        postData += "ffQuotesPayloadJson=" + JSON.stringify(allMembersData);
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/FlexiFuneralQuotesForm.jsp";
        var config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                successApplyCMB.classList.remove("active");
                successApplyCMB.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else if (response.data["error"]) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                successApplyCMB.classList.remove("active");
                successApplyCMB.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else if (response.data["quoteNumber"]) {
                if (response.data["quoteNumber"] === null ||
                    response.data["quoteNumber"] === "null" ||
                    response.data["quoteNumber"] === "") {
                    if (response.data["validationResult"] &&
                        response.data["ffValidationMessages"]) {
                        analyticsService.dtmRecordSiteError("noerrorcode|incorrect data");
                        thankYou.classList.remove("active");
                        success.classList.remove("active");
                        success.classList.add("hidden");
                        successApplyCMB.classList.remove("active");
                        successApplyCMB.classList.add("hidden");
                        error.classList.remove("active");
                        error.classList.add("hidden");
                        fieldsContainer.classList.remove("hidden");
                        var fullValidationMessage = response.data["ffValidationMessages"];
                        _this.quoteDetails.innerHTML =
                            _this.formatValidationMessage(fullValidationMessage);
                    }
                    else {
                        analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                        thankYou.classList.add("active");
                        success.classList.remove("active");
                        success.classList.add("hidden");
                        successApplyCMB.classList.remove("active");
                        successApplyCMB.classList.add("hidden");
                        error.classList.remove("hidden");
                        error.classList.add("active");
                    }
                }
                else {
                    if (response.code) {
                        analyticsService.dtmFormComplete("complete", response.code);
                    }
                    else if (response.status) {
                        analyticsService.dtmFormComplete("complete", response.status);
                    }
                    else {
                        analyticsService.dtmFormComplete("complete", "200");
                    }
                    thankYou.classList.add("active");
                    error.classList.remove("active");
                    error.classList.add("hidden");
                    success.classList.remove("active");
                    success.classList.add("hidden");
                    successApplyCMB.classList.remove("hidden");
                    successApplyCMB.classList.add("active");
                    var totalPremiums_1 = 0;
                    response.data["items"].forEach(function (item) {
                        if (item["premium"]) {
                            totalPremiums_1 += Number(item["premium"]);
                        }
                    });
                    // -- TOTAL COVER AMOUNT -- //
                    if (coverAmount) {
                        coverAmount.innerHTML =
                            "R" +
                                Number.parseFloat(_this.totalCoverAmount.toString()).toFixed(2);
                    }
                    // -- TOTAL PREMIUMS -- //
                    premium.innerHTML =
                        "R" +
                            Number.parseFloat(totalPremiums_1.toString()).toFixed(2);
                    // -- TOTAL QUOTE NUMBER -- //
                    if (response.data["quoteNumber"]) {
                        _this.quoteNumber = response.data["quoteNumber"];
                    }
                }
            }
            else {
                if (response.data["validationResult"] &&
                    response.data["ffValidationMessages"]) {
                    analyticsService.dtmRecordSiteError("noerrorcode|incorrect data");
                    thankYou.classList.remove("active");
                    success.classList.remove("active");
                    success.classList.add("hidden");
                    successApplyCMB.classList.remove("active");
                    successApplyCMB.classList.add("hidden");
                    error.classList.remove("active");
                    error.classList.add("hidden");
                    fieldsContainer.classList.remove("hidden");
                    var fullValidationMessage = response.data["ffValidationMessages"];
                    _this.quoteDetails.innerHTML =
                        _this.formatValidationMessage(fullValidationMessage);
                }
                else {
                    analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                    thankYou.classList.add("active");
                    success.classList.remove("active");
                    success.classList.add("hidden");
                    successApplyCMB.classList.remove("active");
                    successApplyCMB.classList.add("hidden");
                    error.classList.remove("hidden");
                    error.classList.add("active");
                }
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    FormItemFlexiFuneralQuote.prototype.submitCMBForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var success = form.querySelector(".form__success--container");
        var successApplyCMB = form.querySelector(".form__success--container-pc");
        var error = form.querySelector(".form__error--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // original form loader HTML
        var formLoaderHTML = "<img class=\"search__results-busy\" src=\"/file_source/assets/img/spinner.gif\" />\n\t\t<p><strong>Please Note:</strong></p>\n\t\t<p>You have the option to wait for the results as we process your quote. This can take up to 2 minutes to process your quote.</p>\n\t\t<div class=\"access-quote__animation text-center\">\n\t\t\t<div style=\"padding-top:30px; padding-bottom:30px; text-align:center;\"> <i data-component=\"icon\" data-icon=\"form-complete-badge\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \"></i></div>\n\t\t</div>";
        var postData = "";
        postData += "firstname=" + this.mainInsuredAllDetails.firstName;
        postData += "&surname=" + this.mainInsuredAllDetails.surname;
        postData += "&contact=" + this.mainInsuredAllDetails.phoneNumber;
        postData += "&email=" + this.mainInsuredAllDetails.email;
        postData += "&quoteNumber=" + this.quoteNumber;
        // loader + hide form
        // clear form loader of quote processing info
        loader.innerHTML = "<img class=\"search__results-busy\" src=\"/file_source/assets/img/spinner.gif\" />";
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        successApplyCMB.classList.remove("active");
        successApplyCMB.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/FlexiFuneralInsuranceLeadsForm.jsp";
        var config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // service
        this.formsService
            .postForm(url, postData, config)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
                // reset to original form quote loader
                loader.innerHTML = formLoaderHTML;
            }
            else if (response.data
                .toString()
                .toLowerCase()
                .includes("invalid") ||
                response.data.toString().toLowerCase().includes("error")) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
                // reset to original form quote loader
                loader.innerHTML = formLoaderHTML;
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete("complete", response.code, false, "", _this.mainInsuredAllDetails.email.value, _this.mainInsuredAllDetails.phoneNumber.value);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete("complete", response.status, false, "", _this.mainInsuredAllDetails.email.value, _this.mainInsuredAllDetails.phoneNumber.value);
                }
                else {
                    analyticsService.dtmFormComplete("complete", "200", false, "", _this.mainInsuredAllDetails.email.value, _this.mainInsuredAllDetails.phoneNumber.value);
                }
                thankYou.classList.add("active");
                error.classList.remove("active");
                error.classList.add("hidden");
                success.classList.remove("hidden");
                success.classList.add("active");
                // reset to original form quote loader
                loader.innerHTML = formLoaderHTML;
            }
        })
            .catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
        this.resetForm();
    };
    FormItemFlexiFuneralQuote.prototype.resetForm = function () {
        var _loop_4 = function (i) {
            var personToCoverGroup = this_4.personsToCover
                .find(function (x) { return x.name === "person-to-cover-" + i; })
                .closest(".form__group");
            personToCoverGroup.classList.add("form__group--hidden");
            var coverAmountGroup = this_4.coverAmounts
                .find(function (x) { return x.name === "cover-amount-" + i; })
                .closest(".form__group");
            coverAmountGroup.classList.add("form__group--hidden");
            var dateOfBirthGroup = this_4.dateOfBirths
                .find(function (x) { return x.name === "dob-" + i; })
                .closest(".form__group");
            dateOfBirthGroup.classList.add("form__group--hidden");
            var genderGroup = this_4.genders
                .find(function (x) { return x.name === "gender-" + i; })
                .closest(".form__group");
            genderGroup.classList.add("form__group--hidden");
            var firstNameGroup = this_4.firstNames
                .find(function (x) { return x.name === "first-name-" + i; })
                .closest(".form__group");
            firstNameGroup.classList.add("form__group--hidden");
            var lastNameGroup = this_4.lastNames
                .find(function (x) { return x.name === "last-name-" + i; })
                .closest(".form__group");
            lastNameGroup.classList.add("form__group--hidden");
            // -- HORIZONAL LINE TO SHOW SEPARATION -- //
            var hLineGroup = this_4.hLines
                .find(function (x) { return x.id === "h-line-" + i; })
                .closest(".form__group");
            hLineGroup.classList.add("form__group--hidden");
            if (i === 2) {
                var addMemberGroup = this_4.addedMembers
                    .find(function (x) { return x.name === "add-member-" + i; })
                    .closest(".form__group");
                addMemberGroup.classList.remove("form__group--hidden");
            }
            else {
                var addMemberGroup = this_4.addedMembers
                    .find(function (x) { return x.name === "add-member-" + i; })
                    .closest(".form__group");
                addMemberGroup.classList.add("form__group--hidden");
            }
        };
        var this_4 = this;
        // -- Hide Other MEMBER elements -- //
        for (var i = 2; i <= 4; i++) {
            _loop_4(i);
        }
        this.updatePersonsToCover();
    };
    // -- CUSTOM FLEXIBLE FUNERAL VALIDATIONS -- //
    FormItemFlexiFuneralQuote.prototype.flexibleFuneralValidations = function () {
        this.errorDetails = "";
        var validationErrors = false;
        if (this.dateOfBirths) {
            // SKIP -- MAIN MEMBER DATE OF BIRTH -- //
            for (var i = 1; i < 4; i++) {
                var field = this.dateOfBirths[i];
                var form_group = field.closest(".form__group");
                if (form_group) {
                    if (!form_group.classList.contains("form__group--hidden")) {
                        if (field.value !== null && field.value !== "") {
                            if (new Date(field.value) > new Date()) {
                                validationErrors = true;
                                this.errorDetails += "Dates cannot be greater than today's date";
                                break;
                            }
                        }
                    }
                }
            }
        }
        return validationErrors;
    };
    return FormItemFlexiFuneralQuote;
}(Base));
export { FormItemFlexiFuneralQuote };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-flexi-funeral-quote/form-item-flexi-funeral-quote.component.ts
// module id = 907
// module chunks = 0